import React, { useState } from "react";
import RugBrands from "./filters/brands";
import RugYarns from "./filters/yarns";
import RugShanehs from "./filters/shanehs";
import RugDensities from "./filters/densities";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const RugsFilterListSidebar = (props) => {
  const [activeFilters, setActiveFilters] = useState([
    "brands",
    "yarns",
    "shanehs",
  ]);
  const isMobile = useMediaQuery("(max-width: 768px)");
  return (
    <div
      className="text-center"
      style={{
        position: "relative",
        zIndex: props.stepOnboarding === 2 ? 1 : "auto",
      }}
    >
      <div
        className="head-cover"
        style={{
          border:
            props.stepOnboarding === 2
              ? "2px dashed #fff"
              : "1px solid transparent",
        }}
      >
        <RugBrands
          activeFilters={activeFilters}
          changeHandler={props.filterChangeHandler}
          selectedBrands={props.brands}
          stepOnboarding={props.stepOnboarding}
          texts={props.texts}
        />
        {/* <RugYarns
          activeFilters={activeFilters}
          changeHandler={props.filterChangeHandler}
          selectedYarns={props.yarns}
          stepOnboarding={props.stepOnboarding}
        /> */}
        <RugShanehs
          activeFilters={activeFilters}
          changeHandler={props.filterChangeHandler}
          selectedShanehs={props.shanehs}
          stepOnboarding={props.stepOnboarding}
          texts={props.texts}
        />
        <RugDensities
          activeFilters={activeFilters}
          changeHandler={props.filterChangeHandler}
          selectedShanehs={props.shanehs}
          selectedDensities={props.densities}
          stepOnboarding={props.stepOnboarding}
          texts={props.texts}
        />
      </div>
      <div
        style={{
          position: "absolute",
          display: props.stepOnboarding == 2 ? "block" : "none",
          top: isMobile ? 70 : 105,
          left: 0,
          right: 0,
          zIndex: 1,
        }}
      >
        <p
          className="text-center"
          style={{ color: "#fff", fontSize: isMobile ? 16 : 24 }}
        >
          سپس در این می توانید قسمت فیلترها را انتخاب کنید
        </p>
      </div>
    </div>
  );
};

export default RugsFilterListSidebar;
